var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import _ from 'lodash';
import { LEVEL_CODES } from './constants';
import { i18nSymbol } from '@/i18n';
import { LegalStatusApi } from './types/legal-status-api.interface';
import { LegalStatusModel } from './types/legal-status-model.interface';
import { LegalStatusTypes } from './enum';
let LegalStatusServiceImpl = class LegalStatusServiceImpl {
    constructor(_legalStatusApi, _legalStatusModel, _i18n) {
        this._legalStatusApi = _legalStatusApi;
        this._legalStatusModel = _legalStatusModel;
        this._i18n = _i18n;
    }
    get legalStatus() {
        return this._legalStatusModel.legalStatus;
    }
    async initLegalStatusConfig() {
        if (this.legalStatus && !_.isEmpty(this.legalStatus)) {
            return this.legalStatus;
        }
        const legalStatusConfig = await this._legalStatusApi.getLegalStatusConfig();
        this._legalStatusModel.updateLegalStatus(legalStatusConfig);
        this.fixZPrefaceLegalConfig(legalStatusConfig);
        return legalStatusConfig;
    }
    getLegalStatusByCode(code, legalType) {
        return this._legalStatusModel.getLegalStatusByCode(code, legalType);
    }
    getLegalStatusOptionsByType(type) {
        const lang = this._i18n.locale;
        const legalStatusData = this._legalStatusModel.legalStatus;
        const legalStatusOptions = [];
        _.mapValues(legalStatusData, (item) => {
            if (item.codeType !== type)
                return;
            const option = {
                label: _.get(item, `label.${lang}`, ''),
                value: item.code,
            };
            if (_.includes(LEVEL_CODES, item.code)) {
                option.relatedCode = _.map(item.relatedCode, (rc) => {
                    const relatedItem = this.getLegalStatusByCode(rc, LegalStatusTypes.LEGAL_STATUS);
                    return {
                        label: _.get(relatedItem, `label.${lang}`, ''),
                        value: rc,
                    };
                });
            }
            legalStatusOptions.push(option);
        });
        return legalStatusOptions;
    }
    // 左侧过滤项没有支持外部的数据传入，先临时处理，左侧过滤项改造后再移除
    fixZPrefaceLegalConfig(legalStatusConfig) {
        _.set(window, 'zPREFACE.legalConfig', legalStatusConfig);
    }
};
LegalStatusServiceImpl = __decorate([
    injectable(),
    __param(0, inject(LegalStatusApi)),
    __param(1, inject(LegalStatusModel)),
    __param(2, inject(i18nSymbol)),
    __metadata("design:paramtypes", [typeof (_a = typeof LegalStatusApi !== "undefined" && LegalStatusApi) === "function" ? _a : Object, typeof (_b = typeof LegalStatusModel !== "undefined" && LegalStatusModel) === "function" ? _b : Object, Object])
], LegalStatusServiceImpl);
export { LegalStatusServiceImpl };
